import React from "react";
import PropTypes from "prop-types";

import {Box, Grid, Typography} from "@mui/material";

const SectionField = ({name, value}) => {
    return (
        <Grid container item>
            <Grid item xs={12} md={3}>
                <Typography variant="subtitle2" color="textSecondary">
                    {name}
                </Typography>
            </Grid>
            <Grid item xs={12} md={9}>
                <Typography variant="body2">
                    {value}
                </Typography>
            </Grid>
        </Grid>
    )
};

const RequestDetailsSection = ({name, fields}) => {
    return (
        <React.Fragment>
            <Grid item xs={12} md={3}>
                <Typography variant="subtitle1">
                    <Box sx={{fontWeight: 500}}>
                        {name}
                    </Box>
                </Typography>
            </Grid>
            <Grid container item xs={12} md={9} spacing={1}>
                {
                    fields
                        .filter(x => x.visible)
                        .map((f, i) => <SectionField key={i} name={f.name} value={f.value}/>)
                }
            </Grid>
        </React.Fragment>
    )
};

RequestDetailsSection.propTypes = {
    name: PropTypes.string.isRequired,
    fields: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default RequestDetailsSection;